module.exports = __webpack_public_path__ + "static/media/img_qrcode_20210120.c15e0513.png";